import { render, staticRenderFns } from "./CustomBackgroundWrapper.vue?vue&type=template&id=dcc2b18e&scoped=true"
import script from "./CustomBackgroundWrapper.js?vue&type=script&lang=js&external"
export * from "./CustomBackgroundWrapper.js?vue&type=script&lang=js&external"
import style0 from "./CustomBackgroundWrapper.scss?vue&type=style&index=0&id=dcc2b18e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc2b18e",
  null
  
)

export default component.exports